import styled from 'styled-components';

export const FieldRow = styled.div`
  width: 100%;
  margin: 1rem 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const RatingRow = styled(FieldRow)`
  flex-direction: row;
  align-items: center;
  gap: 1rem;
  position: relative;
`;

export const Label = styled.div`
  font-size: 1.4rem;
  color: ${p => p.theme.textColor};
  white-space: nowrap;
`;

export const Input = styled.input`
  width: 100%;
  height: 4rem;
  padding: 0 1rem;
  font-size: 1.4rem;
  font-family: inherit;
  color: ${p => p.theme.textColor};
  border: 0.1rem solid ${p => p.theme.borderColor};
  outline: none;
  box-sizing: border-box;

  &::placeholder {
    color: ${p => p.theme.quaternaryTextColor};
  }
`;

export const Textarea = styled.textarea`
  width: 100%;
  min-height: 9rem;
  padding: 0.8rem 1rem;
  font-size: 1.4rem;
  font-family: inherit;
  color: ${p => p.theme.textColor};
  border: 0.1rem solid ${p => p.theme.borderColor};
  outline: none;
  resize: vertical;
  box-sizing: border-box;

  &::placeholder {
    color: ${p => p.theme.quaternaryTextColor};
  }
`;

export const RatingWrapper = styled.div`
  margin-top: 3rem;
`;

export const ErrorText = styled.div`
  color: ${p => p.theme.tertiaryAltColor};
  font-size: 1.2rem;
  margin-top: 0.4rem;
`;

export const RatingErrorText = styled(ErrorText)`
  position: absolute;
  bottom: -1.2rem;
  left: 0;
  margin-top: 0;
`;
